import { useTheme } from '../context/ThemeProvider';
import { useLocale } from '../context/DynamicLocaleProvider';
import { GlobalMicroButton } from './GlobalMicroButton';
import styles from './GlobalEmptyState.module.css';

interface GlobalEmptyStateProps {
  buttonText?: string;
  onButtonClick?: () => void;
  buttonIcon?: React.ReactNode | string;
}

export default function GlobalEmptyState({ buttonText, onButtonClick, buttonIcon }: GlobalEmptyStateProps) {
  const { t } = useLocale();
  const { theme } = useTheme();
  const isDarkMode = theme === 'dark';

  // Convert string icon paths to img elements
  const renderIcon = () => {
    if (!buttonIcon) return undefined;
    if (typeof buttonIcon === 'string') {
      return <img src={buttonIcon} alt="" width={16} height={16} />;
    }
    return buttonIcon;
  };

  return (
    <div className={styles.emptyState}>
      <img 
        src={isDarkMode ? "/assets/graphics/thescon-empty-state-white.svg" : "/assets/graphics/thescon-empty-state-black.svg"} 
        alt="Empty state" 
        className={styles.graphic}
      />
      <h4 className={styles.title}>{t('global_empty_state_title')}</h4>
      <p className={styles.description}>{t('global_empty_state_description')}</p>
      {buttonText && onButtonClick && (
        <GlobalMicroButton
          onClick={onButtonClick}
          icon={renderIcon()}
        >
          {buttonText}
        </GlobalMicroButton>
      )}
    </div>
  );
}
